<template>
  <div class="animated fadeIn">
    <b-card>

      <!-- HEADER -->
      <template #header>
     
            <b-col md="11">
                <strong  >Vehicle Movement Today</strong>
            </b-col>

            <b-col md="1">
                <b-button class="ml-auto" size="sm" variant="secondary" @click="goback()"> Back
              </b-button>
            </b-col>
            
      </template>

       <b-row class="mt-3 text-center">
            <b-col 
                v-for="(item, index) in summaryList" 
                :key="index"
            >
                <div 
                class="shipment-box clickable"
                  :style="{ backgroundColor: item.color }"
                @click="handleCardClick(item)"
                >
                <div class="title">{{ item.title }}</div>
                <div class="value">{{ item.value }} Vehicles</div>
                </div>
            </b-col>
        </b-row>


        <!-- DRILLDOWN SECTION -->
        <div v-if="showHubSection" class="mt-4 hub-section" >

            <div class="d-flex justify-content-between align-items-center mb-2">
                <strong>LH Vehicle Hubwise Dispatch</strong>
                <b-button size="sm" variant="secondary" @click="showHubSection = false">
                Close
                </b-button>
            </div>

            <b-row class="text-center">
                <b-col 
                v-for="(hub, index) in hubList" 
                :key="index" 
                md="3"
                class="mb-2"
                >
                <div class="hub-box clickable"
                @click="handleCardClickvehicledetails(hub)">
                    <div class="hub-title">{{ hub.name }}</div>
                    <div class="hub-value">{{ hub.count }}</div>
                </div>
                </b-col>
            </b-row>

        </div>
        <!-- VEHICLE DETAILS -->
<div v-if="showVehicleTable" class="mt-3">

  <div class="d-flex justify-content-between mb-2">
    <strong>Vehicle wise Pickup</strong>
    <b-button size="sm" @click="showVehicleTable = false">Close</b-button>
  </div>

  <table class="custom-table">

    <thead>
      <tr>
        <th>Vehicle number</th>
        <th>Vehicle Type</th>
        <th>Vehicle Dimensional Weight</th>
        <th>Transporter company name</th>
        <th>WH Name</th>
        <th>WH ID</th>
        <th>Shipment Count</th>
        <th>Box Count</th>
      </tr>
    </thead>

    <tbody>
      <tr v-for="(row, index) in vehicleTableData" :key="index">

        <td>{{ row.vehicleNo }}</td>
        <td>{{ row.vehicleType }}</td>
        <td>{{ row.weight }}</td>
        <td>{{ row.transporter }}</td>
        <td>{{ row.whName }}</td>
        <td>{{ row.whId }}</td>

        <!-- CLICKABLE SHIPMENT COUNT -->
        <td>
          <span 
            class="clickable-link"
            @click="openLoadPopup(row)"
          >
            {{ row.shipmentCount }}
          </span>
        </td>

        <td>{{ row.boxCount }}</td>

      </tr>
    </tbody>

  </table>

</div>
    </b-card>
    <b-modal v-model="showLoadModal" title="Load ID Details" size="lg">

  <b-table 
    :items="loadData"
    :fields="loadFields"
    bordered
    small
  ></b-table>

</b-modal>
  </div>
</template>

<script>
import CONSTANTS from '@/utils/constants'
import Filters from '@/utils/filters'
import Utils from '@/utils'
import { EventBus } from "./event-bus.js";
export default{
    
data(){
    return{
     summaryList: [
      { title: "Line Haul Vehicle(Mid Mile)", value: 10,  color: "#17a2b8" },
      { title: "National Line Haul Vehicle(Mid Mile)", value: 2, color: "#28a745"  },
      { title: "Direct Delivery Vehicle(Last Mile)", value: 2, color: "#ffc107"  },
      { title: "Pickup Vehicle(First Mile)", value: 4,  color: "#dc3545" },
     
    ],
    showHubSection:false,

      hubList: [
      { name: "BLR Hub", count: 150 },
      { name: "Pune Hub", count: 150 },
      { name: "CHD Hub", count: 150 },
      { name: "HYD Hub", count: 150 },
      { name: "Coimbatore Hub", count: 150 },
      { name: "AMD Hub", count: 150 },
      { name: "Lucknow Hub", count: 150 },
      { name: "Ludhiana Hub", count: 150 },
      { name: "Udaipur Hub", count: 150 },
      { name: "Chennai Hub", count: 150 },
      { name: "Patna Hub", count: 150 },
      { name: "Kolkata Hub", count: 150 },
      { name: "Guwahati Hub", count: 150 }
    ],
    showVehicleTable: false,
    showLoadModal: false,

    vehicleTableData: [
      {
        vehicleNo: "UK07BF5356",
        vehicleType: "12ft",
        weight: 1200,
        transporter: "ASL",
        whName: "BLR WH",
        whId: "WH001",
        shipmentCount: 12,
        boxCount: 59
      }
    ],

    loadFields: [
      { key: "loadId", label: "Load ID" },
      { key: "awb", label: "AWB" },
      { key: "status", label: "Status" }
    ],

    loadData: [
      { loadId: "L12345", awb: "AWB001", status: "Loaded" },
      { loadId: "L12346", awb: "AWB002", status: "Loaded" }
    ]
 
    }
},

methods:{
    handleCardClick(item) {
        console.log(item.title )
     if (item) {
        this.showHubSection = true
     } else {
        this.showHubSection = false
     }
    },
    handleCardClickvehicledetails(hub) {
    console.log("Hub clicked:", hub.name)

    // show vehicle table
    this.showVehicleTable = true

    // 🔥 later: API call based on hub
    // /api/vehicles?hub=BLR
  },

  openLoadPopup(row) {
    console.log("Shipment clicked:", row)

    // 🔥 later: API call based on vehicle
    // /api/load-details?vehicle=UK07BF5356

    this.showLoadModal = true
  },
  goback(){
    this.$router.back()
  }

}
}
</script>

<style scoped>
.shipment-box {
  background-color: #20a8d8;
  padding: 15px;
  border-radius: 8px;
  border: 1px solid #999;
}

.shipment-box .title {
  font-size: 13px;
  font-weight: bold;
  margin-bottom: 5px;
}

.shipment-box .value {
  font-size: 22px;
  font-weight: bold;
  text-align: right;
  padding: 10px;
}
.clickable {
  cursor: pointer;
  transition: 0.2s;
}
.clickable:hover {
  transform: scale(1.02);
}

.hub-section {
  background: #f1f1f1;
  padding: 15px;
  border-radius: 8px;
}

.hub-box {
  background: #d3d3d3;
  padding: 10px;
  border-radius: 6px;
  border: 1px solid #888;
}

.hub-title {
  font-weight: bold;
  font-size: 13px;
}

.hub-value {
  font-size: 18px;
  font-weight: bold;
}
.custom-table {
  width: 100%;
  border-collapse: collapse;
  background: #dff0d8;
}

.custom-table th,
.custom-table td {
  border: 1px solid #666;
  padding: 6px;
  text-align: center;
}

.custom-table th {
  background: #c8e6c9;
  font-weight: bold;
}

.clickable-link {
  color: blue;
  cursor: pointer;
  font-weight: bold;
}

.clickable-link:hover {
  text-decoration: underline;
}
</style>
